import { map } from 'rxjs';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemRepositoryService } from '../../services/item-repository.service';
import { UrgentHxids } from '../../const/urgentHxids';

@Component({
  selector: 'app-catalog-short-description',
  templateUrl: './short-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortDescriptionComponent {
  constructor(public repository: ItemRepositoryService) {}

  isUrgent$ = this.repository.nomenclature$.pipe(
    map((nomenclature) =>
      UrgentHxids.some((hxid) => hxid === nomenclature?.hxid)
    )
  );
}
